var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-contaniner"},[_c('div',{staticClass:"nav-left"},[_c('brand-center')],1),_vm._v(" "),_c('div',{staticClass:"nav-right"},[_vm._t("navbar"),_vm._v(" "),(_vm.judgePermission('getAffairsCount') || _vm.judgePermission('workbench_get_deal_with_list_button'))?_c('todo-nav'):_vm._e(),_vm._v(" "),_c('personal-center')],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }